import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getMetals = async () => {
  const response = await axios.get(`${base_url}metaltype/all`, getAuthHeaders());

  return response.data;
};

const createMetal = async (metal) => {
  const response = await axios.post(`${base_url}metaltype/add`, metal, getAuthHeaders());
  console.log("Hello",response.data)
  return response.data;
};
const updateMetal = async (metal) => {
  const response = await axios.put(
    `${base_url}metaltype/edit/${metal.id}`,
    { metal_name: metal.metalData.metal_name },
    getAuthHeaders()
  );

  return response.data;
};
const getMetal = async (id) => {
  const response = await axios.get(`${base_url}metaltype/get/${id}`, getAuthHeaders());

  return response.data;
};

const deleteMetal = async (id) => {
  const response = await axios.delete(`${base_url}metaltype/delete/${id}`, getAuthHeaders());

  return response.data;
};

const metalService = {
  getMetals,
  createMetal,
  getMetal,
  updateMetal,
  deleteMetal,
};

export default metalService;
